import React from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    IconButton,
    Typography,
} from "@material-tailwind/react";
import { Form, Formik } from "formik";
import FormikRadio from "components/form/formik-radio";
import FormikCheckbox from "components/form/formik-checkbox";
import MaterialIcon from "components/material-icon";
import { buildPresetInitialValues } from "utils/preset-answer-helpers";
import * as Yup from "yup";

export default function CustomResultsDialog(props) {
    const handleClose = () => {
        props.handleClose();
    };

    const question = props.question;
    const responses = props.responses;
    const response = props.responses.custom;

    const handleCustomSubmit = async (values) => {
        props.saveSelection(values);
        props.handleClose();
    };

    const reportAnswer = async (answerNanoid) => {
        props.setReportedAnswer(answerNanoid);
        props.setShowConfirmReportDialog(true);
        props.handleClose();
    };

    const validationSchemaCustom = Yup.array().of(Yup.string().required());

    return (
        <>
            {!!(props.searchResults && props.searchResults.found > 0) && (
                <Dialog
                    open={props.showDialog}
                    handler={handleClose}
                    className="dialog"
                >
                    <DialogHeader className="dialog__header">
                        Results Matching:{" "}
                        {props.searchTerm || "LOADING/UNKNOWN"}
                    </DialogHeader>
                    <DialogBody className="dialog__body">
                        <Typography className="font-body my-2 text-center text-black">
                            Choose one, or more, responses, or go back and add
                            your own.
                        </Typography>
                        <Formik
                            initialValues={{
                                answer: buildPresetInitialValues(
                                    props.searchResults.hits,
                                    response,
                                    question.answer_type,
                                ),
                            }}
                            onSubmit={handleCustomSubmit}
                            validationSchema={validationSchemaCustom}
                        >
                            {({ values, isValid, dirty }) => (
                                <Form>
                                    {props.searchResults.hits.map(
                                        (result, index) => (
                                            <div
                                                className="flex font-body border-b border-gray-700 px-2"
                                                key={index}
                                            >
                                                <div className="flex gap-2 font-body grow text-left mt-2">
                                                    <div className="shrink-0">
                                                        {question.answer_type ===
                                                        "single" && (
                                                            <FormikRadio
                                                                id={`values.answer.0.nanoid`}
                                                                name={`answer.0`}
                                                                color="blue"
                                                                value={
                                                                    result.document
                                                                        .answer_nanoid
                                                                }
                                                            />
                                                        )}
                                                        {question.answer_type ===
                                                        "multiple" && (
                                                            <FormikCheckbox
                                                                id={`values.answer.${index}.nanoid`}
                                                                name={`answer`}
                                                                color="blue"
                                                                value={
                                                                    result.document
                                                                        .answer_nanoid
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                    <div className="flex-1 min-w-0 pt-1.5 mr-3">
                                                        <span className="text-gray-900">
                                                            {result.document.text}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="font-body text-right border-l border-gray-700 my-2">
                                                    <IconButton
                                                        color="red"
                                                        type="button"
                                                        variant="text"
                                                        onClick={() =>
                                                            reportAnswer(
                                                                result.document
                                                                    .answer_nanoid,
                                                            )
                                                        }
                                                    >
                                                        <MaterialIcon
                                                            name="flag"
                                                            size="2xl"
                                                        />
                                                    </IconButton>
                                                </div>
                                            </div>
                                        ),
                                    )}
                                    <div className="font-body my-4 text-center text-black">
                                        Click on the flag (
                                        <MaterialIcon
                                            color="red"
                                            name="flag"
                                            size="xl"
                                        />
                                        ) next to an answer to report any abuse.
                                    </div>
                                    <DialogFooter className="dialog__footer">
                                        <Button
                                            type="submit"
                                            className="btn btn--primary"
                                            variant="filled"
                                            size="lg"
                                            disabled={
                                                !values.answer ||
                                                (question.answer_type === "single"
                                                    ? !values.answer[0]
                                                    : values.answer.filter((v) => v)
                                                        .length === 0)
                                            }
                                        >
                                            Confirm
                                        </Button>
                                        <Button
                                            type="button"
                                            className="btn btn--secondary"
                                            variant="filled"
                                            size="lg"
                                            onClick={handleClose}
                                        >
                                            Cancel
                                        </Button>
                                    </DialogFooter>
                                </Form>
                            )}
                        </Formik>
                    </DialogBody>
                </Dialog>
            )}
        </>
    );
}
